import { ModelCollection } from '/@/modules/core/app/models/ModelCollection';
import { HubspotMeetingNote } from '/@/modules/hubspot/models/HubspotMeetingNote';

export class HubspotMeetingNoteCollection extends ModelCollection {
  /**
   * @param {array} items
   */
  constructor(items = null) {
    super(items, HubspotMeetingNote);
  }

  /**
   * @param {array|HubspotMeetingNoteCollection|null} items
   * @returns {HubspotMeetingNoteCollection}
   */
  static mapModel(items = null) {
    return new this(items, HubspotMeetingNote);
  }
}
